import Link from "components/common/Link";
import useOpenTask from "hooks/useOpenTask";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";

export default function TaskLink({
  taskKey,
  thoughtRecordKey,
}: {
  taskKey: string;
  thoughtRecordKey?: string;
}) {
  const openTask = useOpenTask({
    taskKey: taskKey,
    thoughtRecordKey: thoughtRecordKey,
  });

  const taskTitle = useGetTaskTitleFromTaskKey(taskKey);

  return (
    <Link
      text={taskTitle}
      opacity={0.7}
      onClick={openTask}
      endDecorator={
        <span
          style={{ fontSize: "inherit" }}
          className="material-symbols-rounded"
        >
          north_east
        </span>
      }
    />
  );
}
